// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3q_Wb","inputDescription":"styles_inputDescription__TLjRx"};